import { VendingHistoryStep } from "../../../../model/transaction";
import { formatTimestamp } from "../../../../utils";
import {
	VendingStepType,
	VendingStepStatus,
	TimelineStep,
	TimelineStepStatus,
} from "./types";

// Map backend historySteps to UI timeline steps
export function initializeTimelineFromHistorySteps(
	historySteps: VendingHistoryStep[]
): TimelineStep[] {
	return historySteps
		.map(step => ({
			id: getStepId(step.typeOfEvent),
			typeOfEvent: step.typeOfEvent,
			label: step.vendingStepName || getStepLabel(step.typeOfEvent),
			status: mapBackendStatusToUIStatus(step.subTypeOfEvent),
			timestamp: step.timestamp,
			timeFormated: formatTimestamp(step.timestamp),
			content: undefined,
		}))
		.sort((a, b) => a.typeOfEvent - b.typeOfEvent);
}

// Map backend status enum to UI status
export function mapBackendStatusToUIStatus(subTypeOfEvent: number): TimelineStepStatus {
	switch (subTypeOfEvent) {
		case VendingStepStatus.SUCCESSFUL:
			return 'completed';
		case VendingStepStatus.PENDING:
			return 'pending';
		case VendingStepStatus.FAILED:
			return 'failed';
		case VendingStepStatus.SKIPPED:
			return 'skipped';
		default:
			return 'idle';
	}
}

// Get step ID for timeline rendering
export function getStepId(typeOfEvent: number): string {
	switch (typeOfEvent) {
		case VendingStepType.PAYMENT:
			return 'payment';
		case VendingStepType.TOKEN_GENERATION:
			return 'token_generation';
		case VendingStepType.SMS_EMAIL_DELIVERY:
			return 'sms_email_delivery';
		case VendingStepType.REMOTE_LOAD:
			return 'remote_load';
		default:
			return 'unknown';
	}
}

// Get user-friendly label
export function getStepLabel(typeOfEvent: number): string {
	switch (typeOfEvent) {
		case VendingStepType.TOKEN_GENERATION:
			return 'Token Generated';
		case VendingStepType.SMS_EMAIL_DELIVERY:
			return 'SMS/Email Delivery';
		case VendingStepType.REMOTE_LOAD:
			return 'Remote Load';
		case VendingStepType.PAYMENT:
			return 'Payment';
		default:
			return 'Unknown';
	}
}

// Update timeline step based on SignalR event
export function updateTimelineStepFromEvent(
	timelineSteps: TimelineStep[],
	event: VendingHistoryStep
): TimelineStep[] {
	return timelineSteps.map(step => {
		// Find matching step by typeOfEvent
		if (step.typeOfEvent === event.typeOfEvent) {
			return {
				...step,
				status: mapBackendStatusToUIStatus(event.subTypeOfEvent),
				timestamp: event.timestamp,
				timeFormated: event.timeFormated,
			};
		}
		return step;
	});
}
